/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Job {
    FORGOTTEN_BASKET = 'FORGOTTEN_BASKET',
    EXPIRED_RESERVATION = 'EXPIRED_RESERVATION',
}
